<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openDetailPage="openDetailPage"
      @submitPayRequest="submitPayRequest"
      @checkbox-change="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @batchSubmitPayRequest="batchSubmitPayRequest"
        :check-count="checkCount"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <SubmitPayRequest
      :title="$l('dialog_title_submit_pay_request') || '结算单提交请款'"
      :visible.sync="submitPayRequestOptions.visible"
      :statementData="submitPayRequestOptions.data"
      @reload="submitPayRequestReload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import SubmitPayRequest from '../submit-pay-request'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, SubmitPayRequest },
  data() {
    return {
      usePage: true,
      checkedRow: [],
      submitPayRequestOptions: { visible: false, data: [] },
    }
  },
  computed: {
    checkCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .shipmentPayStatementListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetailPage({ params = {}, query = {} }) {
      this.$router.push({
        name: 'transport-shipmentPayStatementReview-detail',
        params,
        query,
      })
    },
    submitPayRequest(e) {
      if (!e) return
      const { shipmentExpenseStatus, shipmentPayStatementNo } = e
      if (shipmentExpenseStatus) {
        this.$message({
          message: `结算单[${shipmentPayStatementNo}]已提交请款`,
          type: 'warning',
        })
        return
      }
      this.submitPayRequestOptions = {
        visible: true,
        data: [e],
      }
    },
    batchSubmitPayRequest() {
      if (!this.checkCount) {
        this.$message({
          message: '请选择需要提交请款的结算单',
          type: 'warning',
        })
        return
      }

      // 获取已关联请款单的结算单编号
      const errorKeys = this.checkedRow
        .filter((item) => item.shipmentExpenseStatus)
        .map((item) => item.shipmentPayStatementNo)

      if (errorKeys && errorKeys.length) {
        this.$message({
          message: `结算单[${errorKeys.join('][')}]已提交请款`,
          type: 'warning',
        })
        return
      }

      this.submitPayRequestOptions = {
        visible: true,
        data: this.checkedRow,
      }
    },
    submitPayRequestReload() {
      this.reload()
      this.checkedRow = []
      this.$refs.main.clearCheckBoxRow()
    },
  },
}
</script>
